import Nullstack from 'nullstack';
export default function IconStethoscope({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-stethoscope",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M6 4h-1a2 2 0 0 0 -2 2v3.5h0a5.5 5.5 0 0 0 11 0v-3.5a2 2 0 0 0 -2 -2h-1"
  }), "   ", Nullstack.element("path", {
    d: "M8 15a6 6 0 1 0 12 0v-3"
  }), "   ", Nullstack.element("path", {
    d: "M11 3v2"
  }), "   ", Nullstack.element("path", {
    d: "M6 3v2"
  }), "   ", Nullstack.element("circle", {
    cx: "20",
    cy: "10",
    r: "2"
  }), " ");
}